module.exports = __webpack_public_path__ + "static/media/2.2ea3e734.png";